import { Regex } from '@/utils/regex.util';

export const getAlertFromAttributeKey = (attributeKey: string) => {
  // Handle web-login static toggle (no attribute prefix)
  if (attributeKey === 'web-login') {
    return {
      key: '#condition#exposure-web-login',
      name: 'web',
      value: 'login',
    };
  }

  const [isAttribute, attributeName = '', attributeValue = ''] =
    attributeKey.match(Regex.ATTRIBUTE_KEY) || [];

  if (isAttribute) {
    if (attributeName === 'protocol') {
      return {
        key: `#condition#exposure-${attributeValue}`,
        name: attributeName,
        value: attributeValue,
      };
    }

    return {
      key: `#condition#exposure-${attributeName}-${attributeValue}`,
      name: attributeName,
      value: attributeValue,
    };
  }

  return;
};
